import type { UseQueryOptions } from '@tanstack/vue-query';
import { useQuery } from '@tanstack/vue-query';
import { computed, unref } from '@vue/composition-api';
import type { MaybeRef } from '@tanstack/vue-query/build/lib/types';
import { DashboardService } from '../../api/dashboard/services/dashboard.service';
import type { DashboardExpiringDocument } from '../types/dashboard-expiring-document';
import { dashboardKeys } from './dashboard-key-factory';

export const useDashboardExpiringDocuments = (
  showAll: MaybeRef<boolean>,
  options?: UseQueryOptions<DashboardExpiringDocument[]>
) =>
  useQuery<DashboardExpiringDocument[]>({
    ...options,
    queryKey: computed(() => dashboardKeys.expiringDocument(unref(showAll))),
    queryFn: () => DashboardService.getExpiringSoon({ showAll: unref(showAll) }),
  });
